<template>
  <div class="row justify-content-between">
    <div class="col-auto mb-4">
      <div v-if="optionsLoading" class="row g-0 align-items-center">
        <div class="col">
          <i class="fa-loading-black-16"></i>
        </div>
      </div>
      <div v-else-if="options &amp;&amp; options.length" class="row g-0 align-items-center">
        <div v-if="sortBy[0] !== null" class="col">
          <span class="me-2 text-nowrap">{{ sortBy[0] }}</span>
        </div>
        <div class="col-auto">
          <select-one-menu v-model="mutableOption" v-bind:options="options" class="m-0"/>
        </div>
        <div v-if="sortBy[1] !== null" class="col">
          <span class="ms-2 text-nowrap">{{ sortBy[1] }}</span>
        </div>
      </div>
    </div>
    <div class="col-auto mb-4">
      <div v-if="sizeLoading" class="row g-0 align-items-center">
        <div class="col">
          <i class="fa-loading-black-16"></i>
        </div>
      </div>
      <div v-else-if="pageCount > 0" class="row g-0 align-items-center">
        <div class="col">
          <a href="#" v-on:click.prevent="previous()"
             class="btn btn-outline-secondary rounded-0 rounded-start"
             v-bind:class="{'disabled': previousIndex === null}">
            <i class="fa-light fa-chevron-left"></i>
          </a>
        </div>
        <div v-if="pageOf[0] !== null" class="col">
          <span class="mx-2 text-nowrap">{{ pageOf[0] }}</span>
        </div>
        <div class="col">
          <input type="text" v-model="currentPage" v-on:keyup.enter="jump()" size="3"
                 class="form-control text-end rounded-0"
                 v-bind:class="{'ms-2': pageOf[0] === null}"
                 v-bind:disabled="pageCount === 1"/>
        </div>
        <div v-if="pageOf[1] !== null" class="col">
          <span class="mx-2 text-nowrap">{{ pageOf[1] }}</span>
        </div>
        <div class="col">
          <a href="#" v-on:click.prevent="next()"
             class="btn btn-outline-secondary rounded-0 rounded-end"
             v-bind:class="{'disabled': nextIndex === null}">
            <i class="fa-light fa-chevron-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "paginator",
  props: {
    first: {
      type: Number
    },
    max: {
      type: Number
    },
    size: {
      type: Number
    },
    sizeLoading: {
      type: Boolean
    },
    option: {},
    options: {
      type: Array
    },
    optionsLoading: {
      type: Boolean
    }
  },
  data: function () {
    return {
      currentPage: this.page(this.first),
      bundle: {
        id_120: "Sort by {0}",
        id_123: "{0} of {1}"
      }
    }
  },
  computed: {
    pageCount: function () {
      return this.page(this.size) - 1;
    },
    previousIndex: function () {
      return this.first > 0 ? this.first - this.max : null;
    },
    nextIndex: function () {
      return this.first + this.max < this.size ? this.first + this.max : null;
    },
    mutableOption: {
      get: function () {
        return this.option;
      },
      set: function (newValue) {
        this.$emit("sort", newValue);
      }
    },
    sortBy: function () {
      return this.str2arr(this.bundle.id_120, "{0}");
    },
    pageOf: function () {
      var str = this.bundle.id_123;
      str = str.replace("{1}", this.pageCount);
      return this.str2arr(str, "{0}");
    },
  },
  watch: {
    first: function () {
      this.currentPage = this.page(this.first);
    },
    max: function () {
      this.currentPage = this.page(this.first);
    }
  },
  methods: {
    page: function (index) {
      return Math.ceil(index / this.max) + 1;
    },
    previous: function () {
      this.emit(this.previousIndex);
    },
    next: function () {
      this.emit(this.nextIndex);
    },
    jump: function () {
      var page = this.currentPage;
      if (!isNaN(page)) {
        page = page < 1 ? 1 : page > this.pageCount ? this.pageCount : page;
        this.emit((page - 1) * this.max);
      }
    },
    emit: function (newIndex) {
      this.$emit("scroll", {
        page: this.page(newIndex),
        first: newIndex,
        max: this.max
      });
    },
    str2arr: function (str, on) {
      var res = [null, null];
      if (str.indexOf(on) !== -1) {
        var arr = str.split(on);
        var first = arr[0];
        if (first.trim() !== "") {
          res[0] = first;
        }
        if (arr.length > 1) {
          var second = arr[1];
          if (second.trim() !== "") {
            res[1] = second;
          }
        }
      }
      return res;
    }
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
  }
}
</script>
